import { Uri } from '../../../core/models'

export interface VideoTypeDefinition {
  extension?: string
  mimeType?: string
}

export class FlowplayerClipFactory {

  private _supportedTypes: Array<{extensions: string[], mimeType: string}>

  constructor() {
    this._supportedTypes = [
     { extensions: ['m3u8', 'hls'], mimeType: 'application/x-mpegurl' },
     { extensions: ['webm'], mimeType: 'video/webm' },
     { extensions: ['mp4'], mimeType: 'video/mp4' },
     { extensions: ['ogg', 'ogv'], mimeType: 'video/ogg' },
     { extensions: ['flv'], mimeType: 'video/flash' },
     { extensions: ['dash'], mimeType: 'application/dash+xml' }
   ]
  }

  public createClip(url: string, typeDef?: VideoTypeDefinition) {
    const clip = {
      sources: [ this._createSource(this._determineMimeType(url, typeDef), url) ]
    }
    return clip
  }

  private _createSource(mimeType: string, url: string) {
    return { type: mimeType, src: url }
  }

  private _determineMimeType(url: string, typeDef?: VideoTypeDefinition) {
    if (typeDef && !(typeDef.mimeType || typeDef.extension)) {
      throw new Error(`Either 'mimeType' of 'extension' is required in type definition!`)
    }
    let mimeType
    if (!typeDef || typeDef.extension) {
      const fileExtension = typeDef ? typeDef.extension : this._getExtension(url)
      mimeType = this._getTypeByFileExtension(fileExtension)
    } else if (typeDef.mimeType) {
      mimeType = typeDef.mimeType
    }
    return mimeType
  }

  private _getTypeByFileExtension(fileExtension: string) {
     return this._findTypeByFileExtension(fileExtension) || this._guessTypeByFileExtension(fileExtension)
  }

  private _findTypeByFileExtension(fileExtension: string) {
    const lowerCasedExtension = fileExtension.toLowerCase().trim()
    const type = this._supportedTypes.find((value, key) => {
      return value.extensions.includes(lowerCasedExtension)
    })
    return type ? type.mimeType : undefined
  }

  private _guessTypeByFileExtension(fileExtension: string) {
    return `video/${fileExtension}`
  }

  private _getExtension(url: string) {
    const urlObject = new Uri(url)
    const urlPath = urlObject.getPath() || ''
    const usedPath = urlPath.length > 0 ? urlPath : url
    return usedPath.split('.').pop()
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/flowplayer/flowplayer-clip.factory.ts